var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.28 448H7.4V148.9H100.28V448ZM53.79 108.1C24.09 108.1 0 83.5 0 53.8C2.1258e-07 39.534 5.66714 25.8523 15.7547 15.7647C25.8423 5.67714 39.524 0.00999451 53.79 0.00999451C68.056 0.00999451 81.7377 5.67714 91.8253 15.7647C101.913 25.8523 107.58 39.534 107.58 53.8C107.58 83.5 83.48 108.1 53.79 108.1ZM447.9 448H355.22V302.4C355.22 267.7 354.52 223.2 306.93 223.2C258.64 223.2 251.24 260.9 251.24 299.9V448H158.46V148.9H247.54V189.7H248.84C261.24 166.2 291.53 141.4 336.72 141.4C430.72 141.4 448 203.3 448 283.7V448H447.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkin);
export default __webpack_public_path__ + "static/media/linkin.b28ea95150539c3b5f7e153ced06a987.svg";
export { ForwardRef as ReactComponent };